import { loginProvider, walletConnected } from '@/composables/auth'
import { env } from '@/env'
import type { Event } from '@reown/appkit'
import mixpanel from 'mixpanel-browser'
import { watch } from 'vue'

export const trackWalletConnected = (
  address: string,
  event?: Extract<Event, { properties: { name: string } }>,
) => {
  // Extract provider or name from different possible event structures
  const providerOrName =
    event?.properties &&
    ('provider' in event.properties
      ? event.properties.provider
      : event.properties.name)

  const eventDetails = providerOrName
    ? {
      provider: providerOrName,
      user_id: address,
    }
    : {
      provider: loginProvider.value || 'unknown',
      user_id: address,
    }

  mixpanel.track('Wallet Connected', eventDetails)
}

export default function startMixpanel() {
  mixpanel.init(env.mixpanel.token || 'test', {
    debug: env.mixpanel.debug,
    api_host: env.mixpanel.host,
    loaded: () => {
      /* if already connected, identify the user; we need to be sure mixpanel is loaded before identifying */
      watch(
        walletConnected,
        (value) => {
          if (value) {
            mixpanel.identify(value)
          } else {
            loginProvider.value = ''
            mixpanel.reset()
          }
        },
        { immediate: true },
      )
    },
  })
}
